import { createMuiTheme } from '@material-ui/core/styles'

export default createMuiTheme({
  palette: {
    primary: {
      main: '#FFF',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#03B0EE',
      contrastText: '#FFF',
    },
    error: {
      main: '#FF3939',
      contrastText: '#FFF',
    },
  },
  typography: { useNextVariants: true },
})
